import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Datetime from "react-datetime";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import DocumentPicker from "../../Misc/DocumentPicker";
import { getKeysByCriteria } from "../Workdoc/typedoc";
import Jsonform from "../../Misc/Jsonform";

export default class JournalAddModal extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    this.state = {
      pending: false,
      formData: {},
    };
  }

  save = () => {
    this.context
      .ask(
        `Вы действительно хотите внести запись в журнал? Отменить или исправить это действие будет невозможно.`,
        "Внесение записи",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.props.onSave(this.state.formData);
          this.setState({ formData: {} });
        }
      });
  };

  onFormChange = (formData) => {
    this.setState({ formData });
  };

  render() {
    const { fields } = this.props;
    const { formData } = this.state;

    return (
      <Modal size="xl" onHide={this.props.onHide} show={this.props.show}>
        <Blocker on={this.state.pending}>
          <Modal.Header closeButton>
            <Modal.Title>Добавление записи</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Jsonform
              formData={formData}
              fields={fields}
              onChange={this.onFormChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-primary" onClick={this.save}>
              Сохранить
            </button>
            <button className="btn btn-secondary" onClick={this.props.onHide}>
              Отмена
            </button>
          </Modal.Footer>
        </Blocker>
      </Modal>
    );
  }
}
